export const FirstReportModel = {
  address: null,
  effDate: null,
  expDate: null,
  garageCity: null,
  garageState: null,
  policyClaimInfo: { drivNo: 0 },
  garageStreet: null,
  garageZip: null,
  homePhone: null,
  ins1FullName: null,
  lienHolder: null,
  nonRenewPolicy: null,
  policyCars: [],
  policyDriverResps: [],
  policyNo: "",
  policyStatus: null,
  priorDamage: null,
  rescissionAllowPayments: false,
  rescissionApproved: false,
  rescissionApprovedDate: null,
  rescissionPaymentsPrior: false,
  rescissionReason1: null,
  rescissionReason2: null,
  rescissionReason3: null,
  rescissionRequestedPrior: false,
  rescissionApprovedPrior: false,
  rescissionReqDate: null,
  rescissionRequested: false,
  saveDB: false,
  workPhone: null,
  nrPolicy: false,
  resident: false,
};
export const ClaimInfoModel = {
  policyNo: "",
  dol: null,
  rptDate: null,
  entryDate: null,
  reportedBy: "",
  rptMethod: "",
  LossLoc: "",
  lossCity: "",
  lossState: "",
  lossDesc: "",
  isManagerReviewed: false,
  atFault: false,
  atFaultPercent: 0,
  inSuit: false,
  subro: true,
  salvage: false,
  isCovInvestigation: true,
  prorClaims: [],
  lossLoc: "",
};

export const ReminderModel = {
  claimantNo: 0,
  description: null,
  isClaims: true,
  isFirstReport: true,
  location: null,
  noteType: null,
  reminderType: "",
  startTime: null,
  userName: "",
};

export const ClaimantTabModel = {
  carIndex: 1,
  claimNo: "",
  claimantIndex: 1,
  isClaimFR: false,
  policyNo: "",
};

export const SendDataModelClaim = {
  fileName: null,
  sendToo: null,
  sendBy: null,
  message: null,
  indexId: null,
  sendTo: [],
};
export const ClaimantLiabilityModel = {
  ssn: "",
  dob: "",
  gender: null,
  claimanFoundOnMedicare: false,
  witnessesStatements: "",
  providerResp: {},
  attorneyResp: {},
};

export const salvageDataModel = {
  adjuster: "",
  chargesBegin: null,
  dateLossClosed: null,
  dmvReceived: null,
  dmvSent: null,
  lienholderReceipt: null,
  lienholderRequest: null,
  phone: "",
  receiptClosedOn: null,
  salvageYard: "",
  salvageYardDelivered: null,
  status: " ",
  statusDate: null,
  storagePerDay: 0,
  claimNo: "",
  claimantIndex: 1,
};

export const SUINoteModel = {
  claimNo: null,
  claimantNo: null,
  isClaims: false,
  isDiary: false,
  isFirstReport: false,
  manager: false,
  noteType: "SIU",
  notes: "",
};

export const ProviderNoteModel = {
  internalCode: "",
  isDiary: false,
  manager: false,
  noteType: "PROVIDERS",
  notes: "",
};
export const ClaimNoteModel = {
  claimNo: null,
  claimantNo: null,
  isClaims: false,
  isDiary: false,
  isFirstReport: false,
  manager: true,
  noteType: "CLAIMS",
  notes: "",
};
export const RescissionNoteModel = {
  claimNo: null,
  claimantNo: null,
  isClaims: false,
  isDiary: false,
  isFirstReport: false,
  manager: true,
  noteType: "RESCISSION",
  notes: "",
};
export const ClaimantNoteModel = {
  claimNo: null,
  claimantNo: null,
  isClaims: false,
  isDiary: false,
  isFirstReport: true,
  manager: true,
  noteType: "CLAIMANTS",
  notes: "",
};
export const DocumentDataModel = {
  category: null,
  fileNo: null,
  formDesc: null,
  formType: null,
  department: "CLAIMS",
  claimant: null,
  doNotSendWorkFlow: false,
  indexID: null,
  reportFile: null,
  wfClassification: null,
  perilDesc: null,
};
export const AgentDocumentModel = {
  category: null,
  fileNo: null,
  formDesc: null,
  formType: null,
  department: "AGENT",
  claimant: null,
  doNotSendWorkFlow: false,
  indexID: null,
  reportFile: null,
  wfClassification: null,
  perilDesc: null,
};
export const SubrogationModel = {
  dateLossClosed: null,
  adjuster: null,
  respondantCo: null,
  respPolicyNo: null,
  respClaimNo: null,
  respInsured: null,
  respInsHome: null,
  respCompContentation: null,
  status: null,
  rcAdjuster: null,
  adjusterPhone: null,
  adjusterExt: null,
  respCoAddress: null,
  respInsWork: null,
  notes: null,
  respPolicyEffDate: null,
  comparitiveNegligencePct: null,
  respondantAdmittedCNPct: null,
  claimNo: null,
  claimantIndex: null,
};
export const suitModal = {
  indexId: 0,
  claimNo: "",
  claimant: 0,
  suitIndex: 0,
  isSuit: false,
  isDemand: false,
  type: "",
  dateReceived: "",
  ptc: "",
  caseStyle: "",
  issue: "",
  venue: "",
  amtAtIssue: "",
  fcexposure: 0,
  tier: "",
  upcomingEvents: "",
  settlementAmts: 0,
  dateSettled: "",
  status: "",
  isDismissalReceieved: false,
  litAdj: "",
  reasonCode: "",
  demandAdj: "",
  isPay: false,
  isDeny: false,
  datePaid: "",
  caseNo: "",
  venueZip: "",
  dateDue: "",
  providerTaxID: "",
  plaintiffAttyTaxID: "",
  defenseAttyTaxID: "",
  providerLocation: "",
  plaintiffAttyLocation: "",
  defenseAttyLocation: "",
  provInternalCode: null,
  pltfAttyInternalCode: "",
  defAttyInternalCode: null,
};

export const claimsResultModel = {
  claimNo: "",
  policyNo: "",
  dol: "",
  status: "",
  rptDate: "",
  reportedBy: "",
  drivName: null,
  vin: "",
  isCovInvestigation: false,
  claimantDetails: [],
};

export const AddPaymentModel = {
  batchGUId: "",
  postMarkDate: null,
  agencyAddress: "",
  agencyName: "",
  agentCode: "",
  checkAmt: 0,
  chkboxDirectBill: false,
  chkboxIsBinder: false,
  city: "",
  draftAmt: 0,
  effDate: null,
  expDate: null,
  indexId: 0,
  ins1FullName: "",
  lob: "",
  paymentType: "INS",
  policyNo: "",
  state: "",
  status: "",
  totalAmt: 0,
  zip: "",
};

export const PostBatchModel = {
  batchGUId: "",
  batchNo: "",
  grandTotal: "",
  isPostBatch: true,
  testingDateAndTime: "",
};

export const paymentDataModel = {
  indexId: "",
  batchGUId: "",
  policyNo: "",
  paymentType: "",
  checkAmt: 0,
  draftAmt: 0,
  totalAmt: 0,
  batchNo: "",
};

export const NextModel = {
  batchNo: "",
  isPostBatch: false,
  testingDateAndTime: "",
};
export const MGRModel = {
  biClaimLimit: 0,
  biClaimantLimit: 0,
  pipAuth: 0,
  pipClaimantLimit: 0,
  pdClaimantLimit: 0,
};
